// components/ErrorFallback.tsx
import React from "react";

interface ErrorFallbackProps {
  message: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ message }) => {
  return (
    <div className="text-center text-red-600 font-semibold mt-6">{message}</div>
  );
};

export default ErrorFallback;
